import { Component } from '@angular/core';
import { SolDialogsComponent } from '../../dialog/sol-dialogs/sol-dialogs.component';
import { SolPopoversComponent } from '../../popover/sol-popovers/sol-popovers.component';
import { SolNotificationsComponent } from '../../notification/sol-notifications/sol-notifications.component';
import { SolTooltipsComponent } from '../sol-tooltips/sol-tooltips.component';

@Component({
  selector: 'sol-overlays',
  imports: [SolDialogsComponent, SolPopoversComponent, SolNotificationsComponent, SolTooltipsComponent],
  template: `
    <sol-dialogs />
    <sol-popovers />
    <sol-notifications />
    <sol-tooltips />
  `,
})
export class SolOverlaysComponent {}
